if (!customElements.get('kp-avaliacoes')) {
  customElements.define(
    'kp-avaliacoes',
    class KpAvaliacoes extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-kp-filter-toggle]');
        this.menu = this.querySelector('[data-kp-filter-menu]');
        if (!this.toggle || !this.menu) return;

        this.toggle.addEventListener('click', () => this.setOpen(this.menu.hidden));
        this.menu.querySelectorAll('[data-kp-filter]').forEach((button) =>
          button.addEventListener('click', () => this.filter(button))
        );
        this.onOutside = (event) => {
          if (!this.menu.hidden && !this.toggle.contains(event.target) && !this.menu.contains(event.target)) {
            this.setOpen(false);
          }
        };
        this.onKey = (event) => {
          if (event.key === 'Escape' && !this.menu.hidden) {
            this.setOpen(false);
            this.toggle.focus();
          }
        };
        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onKey);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
      }

      setOpen(open) {
        this.menu.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
      }

      filter(button) {
        const value = button.dataset.kpFilter;
        this.menu
          .querySelectorAll('[data-kp-filter]')
          .forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelectorAll('.kp-rev__card').forEach((card) => {
          card.hidden = value !== 'all' && card.dataset.rating !== value;
        });
        this.setOpen(false);
      }
    }
  );
}
